import { Box, IconButton } from '@mui/material';
import { X } from 'lucide-react';
import { FormFieldLabel } from 'src/components/Forms/FormFieldLabel/form-field-label';
import { SettingsSectionCard } from 'src/components/SettingsSection/SettingsSectionCard';
import { SettingsSectionRow } from 'src/components/SettingsSection/SettingsSectionRow';
import type { MergeEntityCardProps } from './merge-target-picker.types';

export const MergeEntityCard = ({
  label,
  icon,
  summary,
  onRemove,
  testId,
}: MergeEntityCardProps) => (
  <Box data-testid={testId}>
    <FormFieldLabel>{label}</FormFieldLabel>
    <SettingsSectionCard>
      <SettingsSectionRow
        icon={icon}
        title={summary.title}
        secondary={summary.secondary}
        controlAlign="center"
        control={
          onRemove ? (
            <IconButton
              size="small"
              aria-label={`Remove ${summary.title}`}
              onClick={onRemove}
              data-testid="merge-target-remove"
            >
              <X size={16} />
            </IconButton>
          ) : undefined
        }
      />
    </SettingsSectionCard>
  </Box>
);
